import { useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-background-100 border-t border-background-300">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 bg-primary-500 rounded-lg flex items-center justify-center">
                <span className="text-foreground-50 font-heading font-bold text-sm">9</span>
              </div>
              <span className="text-foreground-50 font-heading font-bold text-lg whitespace-nowrap">
                911爆料网
              </span>
            </div>
            <p className="text-foreground-300 text-sm leading-relaxed">
              全网吃瓜黑料第一站入口，每日更新网红翻车塌房实锤、反差视频高清资源、明星八卦独家爆料与每日大赛最新动态。
            </p>
          </div>

          <div>
            <h4 className="text-foreground-50 font-heading font-bold text-sm mb-4 whitespace-nowrap">热门分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <a
                    href={`/category/${cat.slug}`}
                    onClick={(e) => { e.preventDefault(); navigate(`/category/${cat.slug}`); }}
                    className="text-foreground-400 text-sm hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-50 font-heading font-bold text-sm mb-4 whitespace-nowrap">关于我们</h4>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="/about"
                  onClick={(e) => { e.preventDefault(); navigate('/about'); }}
                  className="text-foreground-400 text-sm hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  品牌介绍
                </a>
              </li>
              <li>
                <a
                  href="/about"
                  onClick={(e) => { e.preventDefault(); navigate('/about'); }}
                  className="text-foreground-400 text-sm hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  用户口碑
                </a>
              </li>
              <li>
                <a
                  href="/about"
                  onClick={(e) => { e.preventDefault(); navigate('/about'); }}
                  className="text-foreground-400 text-sm hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  联系我们
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-50 font-heading font-bold text-sm mb-4 whitespace-nowrap">关注我们</h4>
            <div className="flex gap-3">
              <a href="#" className="w-10 h-10 rounded-full bg-background-200 flex items-center justify-center text-foreground-400 hover:bg-primary-500 hover:text-foreground-50 transition-all duration-200" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-background-200 flex items-center justify-center text-foreground-400 hover:bg-primary-500 hover:text-foreground-50 transition-all duration-200" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-background-200 flex items-center justify-center text-foreground-400 hover:bg-primary-500 hover:text-foreground-50 transition-all duration-200" aria-label="抖音" rel="nofollow">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-300">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-400 text-xs whitespace-nowrap">
            &copy; 2026 911爆料网 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-400 text-xs hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a>
            <span className="text-foreground-600 text-xs">|</span>
            <a href="#" className="text-foreground-400 text-xs hover:text-primary-400 transition-colors whitespace-nowrap">用户协议</a>
            <span className="text-foreground-600 text-xs">|</span>
            <a href="#" className="text-foreground-400 text-xs hover:text-primary-400 transition-colors whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}